import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { Pagamento } from '../../../models/pagamento';
import { SezionePagamenti } from '../../../models/sezioni/sezione-pagamenti';
import { PagamentiEditComponent } from './pagamenti-edit.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [pagamento-mod-edit]',
  templateUrl: 'pagamento-mod-edit.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class PagamentoModEdit {
  @Output() onReturn: EventEmitter<SezionePagamenti> = new EventEmitter<SezionePagamenti>();
  @ViewChild('formPagamentoEdit') formPagamento: PagamentiEditComponent;

  inizializza(sezione: SezionePagamenti, pagamento: Pagamento, fascicolo: FascicoloFull, urlUpdate: string, urlReadSezioneAltreParti: string, urlReadSezioneControparti: string, urlReadSezioneLegali: string) {
    this.formPagamento.inizializza(sezione, pagamento, fascicolo, urlUpdate, urlReadSezioneAltreParti, urlReadSezioneControparti, urlReadSezioneLegali);
    openModal('modalmodPagamento');
  }

  createForm() {
    this.formPagamento.createForm();
  }

  manageModal(sezionePagamenti: SezionePagamenti) {
      closeModal('modalmodPagamento');
      this.onReturn.emit(sezionePagamenti);
  }
}
